import axios from "axios";
import Swal from 'sweetalert2';

const state = {
  policyList: [], 
  policyArr: [],
  policyArray: [],
  policyID: '',
  policyName: '',
  selectedPolicy: null,
  isEditing: false
};
  
const mutations = {
  initializeStore(state){
    state.policyList = [];
    state.policyArr = [];
    state.policyArray = [];
    state.name_search = '';
    state.isEditing = false;
    state.selectedPolicy = null;
  },
  SET_SELECTED_POLICY(state, policy) {
    state.selectedPolicy = policy;
    state.isEditing = true;
  },
  LIST_POLICIES(state, policies) {
    state.policyList = policies;
  },
  POLICIES_ARRAY(state, policies){
    state.policyArray = policies;
  },
  SET_STATE(state, payload) {
    for (const key in payload) {
        if (payload.hasOwnProperty(key) && key in state) {
            state[key] = payload[key];
        }
    }
  },
  SET_SEARCH_FILTERS(state, search_filter){
    for(const [key, value] of Object.entries(search_filter)){
  
    }
  },
  RESET_SEARCH_FILTERS(state){

  }
};
  
const actions = {
  updateState({ commit }, newState) {
    commit('SET_STATE', newState);
  },
  
  async createTimePolicy({ commit,state }, formData) {
    return axios.post('api/v1/create-time-policy/', formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })
  },

  async fetchTimePolicies({ commit,state }, formData) {
    state.policyArr = [];
    await axios.post(`api/v1/get-time-policies/`,formData)
    .then((response)=>{
      for(let i=0; i< response.data.length; i++){
        state.policyArr.push((response.data[i].name))
      }
      commit('LIST_POLICIES', response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  fetchTimePolicy({ commit,state }, formData) {
    axios.post(`api/v1/get-time-policies/`,formData)
    .then((response)=>{
      state.selectedPolicy = response.data;
      commit('SET_SELECTED_POLICY',response.data);
    })
    .catch((error)=>{
      console.log(error.message);
    })
    
  },
  handleSelectedTimePolicy({ commit, state }, option){
    state.policyArray = [];
    const selectedPolicy = state.policyList.find(policy => (policy.name) === option);
    if (selectedPolicy) {
        state.policyID = selectedPolicy.time_policy_id;
        state.policyName = selectedPolicy.name;
        state.policyArray = [...state.policyArray, selectedPolicy];
    }
    commit('POLICIES_ARRAY', state.policyArray);
      
  },

  async updateTimePolicy({ commit,state }, formData) {
    return axios.put(`api/v1/update-time-policy/`,formData)
    .then((response)=>{
      return response;
    })
    .catch((error)=>{
      console.log(error.message);
      throw error;
    })  
  },

  deleteTimePolicy({ commit,state }, formData) {
    Swal.fire({
      title: "Are you sure?",
      text: `Do you wish to delete Time Policy?`,
      type: 'warning',
      showCloseButton: true,
      showCancelButton: true,
      confirmButtonText: 'Yes Delete Time Policy!',
      cancelButtonText: 'Cancel!',
      customClass: {
          confirmButton: 'swal2-confirm-custom',
          cancelButton: 'swal2-cancel-custom',
      },
      showLoaderOnConfirm: true,
    }).then((result) => {
      if (result.value) {
        axios.post(`api/v1/delete-time-policy/`,formData)
        .then((response)=>{
          if(response.status == 200){
              Swal.fire("Poof! Time Policy removed succesfully!", {
                icon: "success",
              }); 
          }else{
            Swal.fire({
              title: "Error Deleting Time Policy",
              icon: "warning",
            });
          }                   
        })
        .catch((error)=>{
          console.log(error.message);
          Swal.fire({
            title: error.message,
            icon: "warning",
          });
        })
      }else{
        Swal.fire(`Time Policy has not been deleted!`);
      }
    })
  },
};
  
const getters = {
  // users: (state) => state.users,
  // currentUser: (state) => state.currentUser,
};
  
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  
  